<script setup lang="ts">
defineProps<{
  content?: string
  button?: {
    label: string
    to: string
  }
}>()
</script>

<template>
  <div class="mt-12 self-stretch p-6 relative bg-neutral-950 rounded-3xl outline outline-1 outline-offset-[-1px] outline-white/10 flex flex-col md:flex-row justify-between items-center overflow-hidden">
    <!-- Animated background glow -->
    <div class="absolute inset-0 pointer-events-none overflow-hidden">
      <div class="absolute -bottom-48 left-1/2 -translate-x-1/2 w-[952px] h-80 bg-emerald-700/40 rounded-full blur-[100px] opacity-70" />
      <div class="absolute -bottom-40 left-1/2 -translate-x-1/2 w-[952px] h-80 bg-emerald-600/30 rounded-full blur-[100px] opacity-50" />
    </div>

    <div class="relative z-10 md:max-w-[600px] flex flex-col justify-center items-start gap-4">
      <div class="text-white text-sm font-headlines uppercase tracking-tight leading-relaxed">
        <template v-if="content">
          {{ content }}
        </template>
        <template v-else>
          <span>Velara gives you all the pro-level tools from the start — </span><span class="text-white/50">no upgrades needed.</span>
        </template>
      </div>
    </div>

    <div class="relative z-10 mt-6 md:mt-0">
      <UButton
        v-if="button"
        :to="button.to"
        size="xl"
        class="bg-green-600 hover:bg-green-500 text-white rounded-2xl px-11 py-3 font-semibold shadow-[0px_3px_10px_0px_rgba(72,206,188,0.39)] shadow-[0px_0px_0px_3px_rgba(21,146,58,0.20)] shadow-[inset_0px_0px_7px_1px_rgba(255,255,255,0.25)] flex items-center gap-6 group transition-all"
      >
        <span>{{ button.label }}</span>
        <div class="w-2 h-4 border-r-2 border-t-2 border-white rotate-45 group-hover:translate-x-1 transition-transform" />
      </UButton>
      <UButton
        v-else
        to="/"
        size="xl"
        class="bg-green-600 hover:bg-green-500 text-white rounded-2xl px-11 py-3 font-semibold shadow-[0px_3px_10px_0px_rgba(72,206,188,0.39)] shadow-[0px_0px_0px_3px_rgba(21,146,58,0.20)] shadow-[inset_0px_0px_7px_1px_rgba(255,255,255,0.25)] flex items-center gap-6 group transition-all"
      >
        <span>Start Now</span>
        <div class="w-2 h-4 border-r-2 border-t-2 border-white rotate-45 group-hover:translate-x-1 transition-transform" />
      </UButton>
    </div>
  </div>
</template>
